import React from "react";
import {  Paper,
  Typography,
  Box,
  alpha,
  useTheme,
  Divider,
  Stack,
  Chip,} from "@mui/material";
import Grid from "@mui/material/Grid";
import {
  AccountCircle as UserIcon,
  Badge as RolesIcon,
} from "@mui/icons-material";
import { useUserContext } from "../../Contexts/UserContext";

// Samma snygga datavisning som i Ship Particulars
const InfoRow = ({ label, value }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography
      variant="caption"
      sx={{
        color: "text.secondary",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.5,
        display: "block",
        mb: 0.5,
      }}
    >
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 600 }}>
      {value || "—"}
    </Typography>
  </Box>
);

const Account = () => {
  const { user } = useUserContext();
  const theme = useTheme();

  const sectionStyle = {
    p: 3,
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 2,
    bgcolor: alpha(theme.palette.background.paper, 0.5),
    elevation: 0,
  };

  return (
    <Box sx={{ p: 3, maxWidth: 900, margin: "0 auto" }}>
      <Typography
        variant="subtitle2"
        sx={{
          mb: 3,
          fontWeight: 800,
          textTransform: "uppercase",
          letterSpacing: 1.5,
          color: "text.secondary",
        }}
      >
        Logged In User
      </Typography>

      <Grid container spacing={3}>
        <Grid size={12}>
          <Paper sx={sectionStyle}>
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              sx={{ mb: 3 }}
            >
              <UserIcon color="primary" />
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Profile Details
              </Typography>
            </Stack>

            <InfoRow label="Username" value={user?.username} />
            <InfoRow
              label="Full Name"
              value={`${user?.firstName || ""} ${user?.lastName || ""}`.trim()}
            />
            <InfoRow label="Email Address" value={user?.email} />
          </Paper>
        </Grid>
        <Grid size={12}>
          <Paper sx={sectionStyle}>
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              sx={{ mb: 3 }}
            >
              <RolesIcon color="primary" />
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Assigned Roles
              </Typography>
            </Stack>
            <Divider sx={{ mb: 2, borderStyle: "dashed" }} />
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              flexWrap="wrap"
              useFlexGap
            >
              {(user?.roles || []).length > 0 ? (
                user.roles.map((role) => (
                  <Chip
                    key={role}
                    label={role}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No roles assigned.
                </Typography>
              )}
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Account;
